// src/services/helpSupport/helpSupportApi.ts

import publicApi from "../../lib/publicApi";
import baseApi from "../../lib/baseApi";

import {
  HelpSupportBootstrap,
  HelpSupportTicket,
  CreateHelpSupportTicketPayload,
  CreateHelpSupportTicketResponse,
  HelpSupportTicketReplyPayload,
  HelpSupportTicketResponse,
} from "../../types/helpSupport/helpSupportTypes";


// ------------------------------------------------------------
// Public bootstrap
// ------------------------------------------------------------

export const fetchHelpSupportBootstrap =
  async (): Promise<HelpSupportBootstrap> => {
    const { data } = await publicApi.get(
      "/help-support/bootstrap/",
    );

    return data;
  };


// ------------------------------------------------------------
// Create ticket
// ------------------------------------------------------------

export const createHelpSupportTicket = async (
  payload: CreateHelpSupportTicketPayload,
): Promise<CreateHelpSupportTicketResponse> => {
  const { data } = await baseApi.post(
    "/help-support/tickets/",
    {
      ...payload,
      source: payload.source ?? "settings",
      client_platform:
        payload.client_platform ?? "web",
    },
  );

  return data;
};


// ------------------------------------------------------------
// My tickets
// Prepared now for future Support Center expansion.
// ------------------------------------------------------------

export const fetchMyHelpSupportTickets =
  async (): Promise<HelpSupportTicket[]> => {
    const { data } = await baseApi.get(
      "/help-support/tickets/",
    );

    if (Array.isArray(data)) {
      return data;
    }

    if (Array.isArray(data?.results)) {
      return data.results;
    }

    return [];
  };


// ------------------------------------------------------------
// Ticket detail
// ------------------------------------------------------------

export const fetchHelpSupportTicket = async (
  publicId: string,
): Promise<HelpSupportTicket> => {
  const { data } = await baseApi.get(
    `/help-support/tickets/${encodeURIComponent(publicId)}/`,
  );

  return data;
};


// ------------------------------------------------------------
// Reply
// ------------------------------------------------------------

export const replyToHelpSupportTicket = async (
  publicId: string,
  payload: HelpSupportTicketReplyPayload,
): Promise<HelpSupportTicketResponse> => {
  const { data } = await baseApi.post(
    `/help-support/tickets/${encodeURIComponent(publicId)}/reply/`,
    payload,
  );

  return data;
};